import { render, staticRenderFns } from "./DownloadToExcel.vue?vue&type=template&id=106731f2&"
import script from "./DownloadToExcel.vue?vue&type=script&lang=js&"
export * from "./DownloadToExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports